import styled from 'styled-components';

// Must cover every floating layer — modals, panels, toasts — so no app UI is
// interactable while the block is up.
export const Base = styled.div`
	position: fixed;
	inset: 0;
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
`;

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	max-width: 400px;
	padding: 0 24px;
	gap: 16px;
`;

export const Brand = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 12px;
`;

export const Heading = styled.div`
	font-size: 20px;
	font-weight: 600;
`;

export const Body = styled.div`
	font-size: 14px;
	line-height: 1.6;
	color: ${({ theme }) => theme.gray[700]};
`;

export const CtaWrap = styled.div`
	margin-top: 8px;
`;

export const Footer = styled.div`
	margin-top: 20px;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const FooterLink = styled.button`
	background: none;
	border: none;
	padding: 0;
	font-size: 12px;
	font-family: inherit;
	color: ${({ theme }) => theme.gray[600]};
	text-decoration: underline;

	&:hover {
		color: ${({ theme }) => theme.gray[1000]};
	}
`;
